module.exports = __webpack_public_path__ + "img/Alisha.ca876704.jpg";